/* @flow */
import * as React from 'react';

import Link from 'components/Link.jsx';

type Props = {
  label: React.Element<any>,
  url: string,
  method: 'to' | 'href',
};

function LinkCell({ label, url, method }: Props) {
  if (!url || !label) {
    return null;
  }

  if (method === 'href') {
    return <Link href={url}>{label}</Link>;
  }

  return <Link to={url}>{label}</Link>;
}

export function getLinkCellGenerator(
  urlFieldName: string,
  method: 'to' | 'href',
  label: React.Element<any>
) {
  return (data: Object) => {
    return <LinkCell url={data[urlFieldName]} method={method} label={label} />;
  };
}
